export default "__VITE_ASSET__Do4Ye5J3__"